import { render, staticRenderFns } from "./SubscribedOffersPrices.vue?vue&type=template&id=5c74c8f6&scoped=true&"
import script from "./SubscribedOffersPrices.vue?vue&type=script&lang=js&"
export * from "./SubscribedOffersPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c74c8f6",
  null
  
)

export default component.exports